import React, { useEffect, useState } from "react";
import "../css/Dashboard.css"
import { Card, CardActions, CardContent, Grid2, Paper, Typography } from "@mui/material";
import miAxios from "../api/axios";

import VisibilityIcon from '@mui/icons-material/Visibility';
import LocalGroceryStoreIcon from '@mui/icons-material/LocalGroceryStore';
import FavoriteIcon from '@mui/icons-material/Favorite';

import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from 'recharts';

import PeopleIcon from '@mui/icons-material/People';
import { useAuth } from "../hooks/AuthProvider";
import Wait from "../components/Wait";

export default function Dashboard(props) {
    const [registrados, setRegistrados] = useState(0)
    const [android, setAndroid] = useState(0)
    const [iphone, setIphone] = useState(0)
    const [validados, setValidados] = useState(0)
    const [activos, setActivos] = useState(0)
    const [balance, setBalance] = useState("0.00")
    const [mensaje, setMensaje] = useState("")
    const [procesando, setProcesando] = useState(false)
    const [chartData, setChartData] = useState([]);
    const [chartRecargas, setChartRecargas] = useState([])

    const [ayerVideos, setAyerVideos] = useState(0)
    const [ayerCatalogo, setAyerCatalogo] = useState(0)
    const [ayerItems, setAyerItems] = useState(0)
    const [hoyVideos, setHoyVideos] = useState(0)
    const [hoyCatalogo, setHoyCatalogo] = useState(0)
    const [hoyItems, setHoyItems] = useState(0)
    const [ayerLikes, setAyerLikes] = useState(0)
    const [ayerMensajes, setAyerMensajes] = useState(0)
    const [hoyLikes, setHoyLikes] = useState(0)
    const [hoyMensajes, setHoyMensajes] = useState(0)

    const [mesOrdenesCantidad, setMesOrdenesCantidad] = useState(0)
    const [mesOrdenesTotal, setMesOrdenesTotal] = useState(0.00)
    const [hoyOrdenesCantidad, setHoyOrdenesCantidad] = useState(0)
    const [hoyOrdenesTotal, setHoyOrdenesTotal] = useState(0.00)

    const user = useAuth()
    const axios = miAxios(user.handleLogout)

    useEffect(() => {
        actTodo()
    }, [])

    useEffect(() => {
        const intervalId = setInterval(actTodo, 60000); // 60000 ms = 1 minuto

        return () => clearInterval(intervalId);
    }, []); // El array de dependencias vacío [] asegura que el efecto se ejecute solo una vez


    const actTodo = async () => {
        try {
            const results = await Promise.all([
                actDatos(),
                datosReacciones(),
                datosOrdenes()
            ]);
        } catch (error) {
            console.log(error)
        }

    }

    const actDatos = async () => {
        setProcesando(true)
        try {
            const response = await axios.get("dashboard/paneles-prov");
            const data = response.data;


            if (data.respuesta == "S") {
                setAyerVideos(data.ayer_videos)
                setAyerCatalogo(data.ayer_catalogo)
                setAyerItems(data.ayer_items)
                setHoyVideos(data.hoy_videos)
                setHoyCatalogo(data.hoy_catalogo)
                setHoyItems(data.hoy_items)
                setAyerLikes(data.ayer_likes)
                setAyerMensajes(data.ayer_mensajes)
                setHoyLikes(data.hoy_likes)
                setHoyMensajes(data.hoy_mensajes)
                setMesOrdenesCantidad(data.mes_ordenes_cantidad)
                setMesOrdenesTotal(data.mes_ordenes_total)
                setHoyOrdenesCantidad(data.hoy_ordenes_cantidad)
                setHoyOrdenesTotal(data.hoy_ordenes_total)
            } else {
                props.error();
            }
        } catch (error) {
            setMensaje(error);

        }
        setProcesando(false)

    }

    const datosReacciones = async () => {
        setProcesando(true)
        try {
            const response = await axios.get('dashboard/detalle_reacciones');

            if (response.data && response.data.respuesta === 'S' && response.data.datos) {
                setChartData(response.data.datos);
            } else {
                //setError('No se pudieron obtener los datos del gráfico.');
            }
        } catch (err) {

        } finally {
            setProcesando(false);
        }
    };

    const datosOrdenes = async () => {
        setProcesando(true)
        try {
            const response = await axios.get('dashboard/detalle_ordenes_prov');

            if (response.data && response.data.respuesta === 'S' && response.data.datos) {
                const nl = response.data.datos.map((row) => {
                    return {
                        fecha: row.fecha,
                        cantidad: row.likes
                    }
                })
                setChartRecargas(nl);
            } else {
                //setError('No se pudieron obtener los datos del gráfico.');
            }
        } catch (err) {

        } finally {
            setProcesando(false);
        }
    };

    const actBalance = async () => {
        setProcesando(true)

        try {
            const response = await axios.post("recargas/balance");
            const data = response.data;
            if (data.respuesta == "S") {
                setBalance(data.mensaje)
            } else {

            }

        } catch (error) {
            console.log(error)
            setMensaje(error)
        }

        setProcesando(false)
    }

    return (<div className="Dash-cuerpo">
        <Wait procesando={procesando} />
        <div className="Main-paneles Main-paneles-3">
            <div className="Main-paneles-cuadros">
                <Card className="Main-paneles-cards">
                    <CardContent>
                        <div className="Main-paneles-cards-titulo">
                            <div className="Main-paneles-titulo">Visualizaciones</div>
                            <div className="Main-paneles-cards-img"><VisibilityIcon fontSize="small" /></div>
                        </div>
                        <div className="Main-paneles-cards-visualizaciones">
                            <div className="Main-paneles-cards-visualizaciones-rows Head">
                                <div></div>
                                <div>Videos</div>
                                <div>Catálogo</div>
                                <div>Items</div>
                            </div>
                            <div className="Main-paneles-cards-visualizaciones-rows">
                                <div className="Main-paneles-cards-visualizaciones-rows-tit">Ayer</div>
                                <div>{ayerVideos}</div>
                                <div>{ayerCatalogo}</div>
                                <div>{ayerItems}</div>
                            </div>
                            <div className="Main-paneles-cards-visualizaciones-rows">
                                <div className="Main-paneles-cards-visualizaciones-rows-tit">Hoy</div>
                                <div>{hoyVideos}</div>
                                <div>{hoyCatalogo}</div>
                                <div>{hoyItems}</div>
                            </div>
                        </div>

                    </CardContent>
                </Card>
            </div>
            <div className="Main-paneles-cuadros">
                <Card className="Main-paneles-cards">
                    <CardContent>
                        <div className="Main-paneles-cards-titulo">
                            <div className="Main-paneles-titulo">Reacciones</div>
                            <div className="Main-paneles-cards-img"><FavoriteIcon fontSize="small" /></div>
                        </div>
                        <div className="Main-paneles-cards-reacciones">
                            <div className="Main-paneles-cards-reacciones-rows Head">
                                <div></div>
                                <div>Likes</div>
                                <div>Mensajes</div>
                            </div>
                            <div className="Main-paneles-cards-reacciones-rows">
                                <div className="Main-paneles-cards-reacciones-rows-tit">Ayer</div>
                                <div>{ayerLikes}</div>
                                <div>{ayerMensajes}</div>
                            </div>
                            <div className="Main-paneles-cards-reacciones-rows">
                                <div className="Main-paneles-cards-reacciones-rows-tit">Hoy</div>
                                <div>{hoyLikes}</div>
                                <div>{hoyMensajes}</div>
                            </div>
                        </div>
                    </CardContent>
                </Card>
            </div>
            <div className="Main-paneles-cuadros">
                <Card className="Main-paneles-cards">
                    <CardContent>
                        <div className="Main-paneles-cards-titulo">
                            <div className="Main-paneles-titulo">Ordenes</div>
                            <div className="Main-paneles-cards-img"><LocalGroceryStoreIcon fontSize="small" /></div>
                        </div>
                        <div className="Main-paneles-cards-ordenes">
                            <div className="Main-paneles-cards-ordenes-rows Head">
                                <div></div>
                                <div>Cantidad</div>
                                <div>Total</div>
                            </div>
                            <div className="Main-paneles-cards-ordenes-rows">
                                <div className="Main-paneles-cards-ordenes-rows-tit">Mes</div>
                                <div>{mesOrdenesCantidad}</div>
                                <div>{parseFloat(mesOrdenesTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                            </div>
                            <div className="Main-paneles-cards-ordenes-rows">
                                <div className="Main-paneles-cards-ordenes-rows-tit">Hoy</div>
                                <div>{hoyOrdenesCantidad}</div>
                                <div>{parseFloat(hoyOrdenesTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                            </div>
                        </div>
                    </CardContent>
                </Card>
            </div>

        </div>
        <div className="Main-graficos-rows">
            <div>
                <Paper elevation={10} sx={{ width: "100%", height: "100%" }}  >
                    <div className="Dash-graf-titulo">
                        <Typography width={"100%"} sx={{ textAlign: "center" }} color="coopinfa">Reacciones</Typography>
                    </div>
                    <ResponsiveContainer width="100%" height="100%">
                        <LineChart data={chartData} margin={{ bottom: 30, right: 20 }} >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="fecha" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Line
                                type="monotone"
                                dataKey="likes"
                                stroke="#8884d8"
                                activeDot={{ r: 8 }}
                                name="Like's"
                            />
                            <Line
                                type="monotone"
                                dataKey="mensajes"
                                stroke="#82ca9d"
                                name="Mensajes"
                            />
                        </LineChart>
                    </ResponsiveContainer>
                </Paper>
            </div>
            <div>
                <Paper elevation={10} sx={{ width: "100%", height: "100%" }}  >
                    <div className="Dash-graf-titulo">
                        <Typography width={"100%"} sx={{ textAlign: "center" }} color="coopinfa">Ordenes</Typography>
                    </div>
                    <ResponsiveContainer width="100%" height="100%">
                        <LineChart data={chartRecargas} margin={{ bottom: 30, right: 20 }} >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="fecha" />
                            <YAxis />
                            <Tooltip />
                            <Line
                                type="monotone"
                                dataKey="cantidad"
                                stroke="#8884d8"
                                activeDot={{ r: 8 }}
                                name="Ordenes"
                            />
                        </LineChart>
                    </ResponsiveContainer>
                </Paper>
            </div>
        </div>


    </div>
    )
}